import InvoiceForm from "@app/components/forms/invoice/invoice-form.tsx";
import { PageContainer } from "@app/components/page-container.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_manager/invoice/create")({
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageContainer title={"Create Invoice"} from={"/invoice"}>
            <InvoiceForm />
        </PageContainer>
    );
}
